const supervisorWallboards = state => structuredClone(state.supervisorWallboards);

const selectedSupervisorWallboard = state => structuredClone(state.selectedSupervisorWallboard);

const getSupervisedAgents = state => {
  return state.supervisedAgents;
};

const getSupervisedInteractions = state => {
  return state.supervisedInteractions;
};

export default {
  supervisorWallboards,
  selectedSupervisorWallboard,
  getSupervisedAgents,
  getSupervisedInteractions
};
